/**
 * LocalStorage state management for signup wizard
 */

const STORAGE_KEY = 'signupWizardState';
const TEST_KEY = '__storage_test__';

// Check localStorage availability once at module load (Safari private mode throws)
let storageAvailable = false;
try {
    localStorage.setItem(TEST_KEY, TEST_KEY);
    localStorage.removeItem(TEST_KEY);
    storageAvailable = true;
} catch (e) {
    // Storage not available (Safari private mode, quota exceeded, etc.)
}

export function loadState() {
    if (!storageAvailable) return null;

    try {
        const savedState = localStorage.getItem(STORAGE_KEY);
        if (savedState) {
            const parsed = JSON.parse(savedState);

            // Remove any old 'touched' state from localStorage (legacy cleanup)
            delete parsed.touched;

            // Format values for consistency
            if (parsed.day) parsed.day = String(parsed.day).padStart(2, '0');
            if (parsed.month) parsed.month = String(parsed.month).padStart(2, '0');
            if (parsed.year) parsed.year = String(parsed.year);

            return parsed;
        }
    } catch (e) {
        console.error('[Signup] Failed to load state:', e);
    }
    return null;
}

export function saveState(state) {
    if (!storageAvailable) return;

    const stateToSave = {
        currentStep: state.currentStep,
        name: state.name || '',
        email: state.email || '',
        day: state.day ? String(state.day).padStart(2, '0') : '',
        month: state.month ? String(state.month).padStart(2, '0') : '',
        year: state.year ? String(state.year) : '',
        sex: state.sex || '',
        username: state.username || '',
        // Password intentionally NOT persisted - security risk if stored in localStorage
        cityId: state.cityId || '',
        cityName: state.cityName || '',
        cityCountryIso: state.cityCountryIso || '',
        homeCityId: state.homeCityId || '',
        homeCityName: state.homeCityName || '',
        homeCityCountryIso: state.homeCityCountryIso || '',
        // Don't persist touched state - validation should reset on page reload
        userLat: state.userLat,
        userLon: state.userLon,
        locationRequested: state.locationRequested || false,
        locationReady: state.locationReady || false
    };

    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(stateToSave));
    } catch (e) {
        console.error('[Signup] Failed to save state:', e);
    }
}

export function clearState() {
    if (!storageAvailable) return;

    try {
        localStorage.removeItem(STORAGE_KEY);
    } catch (e) {
        console.error('[Signup] Failed to clear state:', e);
    }
}
